
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesses/[type]",
      function () {
        return require("private-next-pages/businesses/[type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesses/[type]"])
      });
    }
  